<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <g fill="none"><g fill="currentColor"><path d="M11.2 0C17.7 0 23 5.4 23 12 23 18.6 17.7 24 11.2 24 6.8 24 3 21.6 1 17.9 1.9 19.1 2.9 19.7 4.1 19.7L4.1 19.7 11.3 19.7 11.8 16.6C10.6 16.6 9.5 16.6 8.6 16.6L8.5 16.6C8.4 16.6 8.3 16.6 8.2 16.6L8 16.6C8 16.6 7.9 16.6 7.9 16.6L7.7 16.6C7.7 16.6 7.6 16.6 7.6 16.6L6.7 16.6C6.7 16.6 6.7 16.6 6.7 16.6L6.5 16.6C6.5 16.6 6.5 16.6 6.5 16.6L6.4 16.6C6.3 16.6 6.3 16.6 6.2 16.6L6.2 16.6C5.8 16.6 5.6 16.6 5.6 16.6 4.7 16.6 4.2 16 4.2 15 4.2 14.9 4.2 14.7 4.2 14.4L4.2 14.4C4.2 14.3 4.2 14.3 4.2 14.3L4.2 14.2C4.2 14.1 4.2 14.1 4.2 14.1L4.2 14.1C4.2 13.8 4.2 13.4 4.2 13L4.2 13 10.2 13 10.7 10 4.2 10 4.2 6.5 11.4 6.5 11.9 3.3 3.1 3.3C5.2 1.3 8.1 0 11.2 0L11.2 0Z"/></g></g>

  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '  Artboard',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcyEdenred',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>